const basePathRegex = new RegExp(`\\${process.env.NEXT_PUBLIC_BASE_PATH}`);

const removeBasePath = (path: string) => path.replace(basePathRegex, '');

export default function getRelativePath(href: string) {
  try {
    const url = new URL(href);
    return removeBasePath(url.pathname);
  } catch {
    return removeBasePath(href);
  }
}
